export default __webpack_public_path__ + "static/media/tres_preparacion.77083cc2.png";